import {FormField} from "../form-field/form-field";

export class FormFieldHtml extends FormField{
    constructor(scope,$root){
        super(scope,$root);
    }

    getVal(){
        return "";
    }

    setVal(val,noEvent){
        //nothing to do
    }

    ready(){
        super.ready();

    }
}
